import React, {Component} from 'react';
import { CircleQuestionMark } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";
import '../listWithActions/list_gaia.scss';
import * as reduxSelectors from '../store/application.reducers';
import {connect} from 'react-redux';
import UserSearch, {FindEmployees, ExceptionsRoles} from '../input/UserSearch.component';
import * as _ from "lodash";
import translate from '../translations/translations.wrapper.jsx';
import {EditDeleteButtons, SaveCancelButtons} from 'utils/listActionButtons.component';
import {handleError} from "utils/errorHandle.function.js";
import {Tag, TagType} from "components/common/Tag.component.tsx";

export class Exceptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            showNewRow: false
        };
        this.addRow = this.addRow.bind(this);
        this.cancelAddNewRow = this.cancelAddNewRow.bind(this);
        this.enterEditMode = this.enterEditMode.bind(this);
        this.exitEditMode = this.exitEditMode.bind(this);
        this.saveNewRow = this.saveNewRow.bind(this);
        this.saveRow = this.saveRow.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.mapDataBeforeSave = this.mapDataBeforeSave.bind(this);
        this.isSaveDisabled = this.isSaveDisabled.bind(this);
    }

    isSaveDisabled(requester, approver, showRole, role) {
        // Return true (disabled) if requester is null or undefined
        if (!requester) {
            return true;
        }

        // Return true (disabled) if approver is an empty array
        if (Array.isArray(approver) && approver.length === 0) {
            return true;
        }

        // Return true (disabled) if approver is null or undefined (when not an array)
        if (!Array.isArray(approver) && !approver) {
            return true;
        }

        // Return true (disabled) if showRole is true and role is null or undefined
        if (showRole && !role) {
            return true;
        }

        // Return false (enabled) if all validations pass
        return false;
    }

    addRow() {
        this.setState({
            showNewRow: true,
            editMode: true
        });
    }

    cancelAddNewRow() {
        this.setState({
            showNewRow: false,
            editMode: false
        });
    }

    enterEditMode() {
        this.setState({editMode: true});
    }

    exitEditMode() {
        this.setState({editMode: false});
    }

    saveNewRow(newRow) {
        let newExceptions = this.props.data ? _.cloneDeep(this.props.data) : [];

        let duplicateException = false;

        newExceptions.forEach((row) => {
            if (row.value === newRow.value && row.role.value === newRow.role.value)
                duplicateException = true;
        });

        if (duplicateException) {
            handleError({
                errorTitle: this.props.translate("costUnitExceptions.duplicateExceptionTitle"),
                errorMessages: this.props.translate("costUnitExceptions.duplicateException")
            });

            this.cancelAddNewRow();
            return;
        }

        newExceptions.push(newRow);

        this.props.changeExceptions(newExceptions);

        this.cancelAddNewRow();

        const mappedExceptions = this.mapDataBeforeSave(newExceptions);

        if (this.props.saveException) {
            const mappedNewException = mappedExceptions[mappedExceptions.length - 1];

            this.props.saveException(mappedExceptions, mappedNewException);
        } else {
            this.props.saveExceptions(mappedExceptions);
        }
    }

    deleteRow(row) {
        const roleNameExceptionId = this.props.data[row].id;

        let exceptions = _.cloneDeep(this.props.data);
        exceptions.splice(row, 1);

        this.props.changeExceptions(exceptions);
        let newExceptions = this.mapDataBeforeSave(exceptions);

        if (this.props.deleteException) {
            this.props.deleteException(roleNameExceptionId);
        } else {
            this.props.saveExceptions(newExceptions);
        }

    }

    mapDataBeforeSave(data) {
        return data.map((exception) => {
            let users = exception.users ? (Array.isArray(exception.users) ? exception.users : [exception.users]).map((user => {
                return user.value
            })) : [];
            let result = {
                user: exception.value,
                users: users
            };

            if (this.props.showAuto)
                result.automaticApproval = exception.automaticApproval;
            if (exception.role)
                result.role = exception.role.value;
            result.id = exception.id;

            return result;
        });
    }


    saveRow(newRow, index) {

        let rows = _.cloneDeep(this.props.data);
        rows[index] = newRow;

        this.props.changeExceptions(rows);

        let newExceptions = this.mapDataBeforeSave(rows);

        this.props.saveExceptions(newExceptions);
    }


    render() {
        let rows = _.cloneDeep(this.props.data);

        let lines = (rows) ? rows.map((row, index) => {
            return <ExceptionsRow data={row}
                                  key={row.id || row.value}
                                  save={this.saveRow}
                                  isSaveDisabled={this.isSaveDisabled}
                                  index={index}
                                  disabled={this.state.editMode || !this.props.allowActions}
                                  showAuto={this.props.showAuto}
                                  showRole={this.props.showRole}
                                  translate={this.props.translate}
                                  enterEditMode={this.enterEditMode}
                                  exitEditMode={this.exitEditMode}
                                  allowActions={this.props.allowActions}
                                  deleteRow={this.deleteRow}/>

        }) : [];

        return (
            <div className="actions-list no-side-padding">

                <ExceptionsHeaderRow translate={this.props.translate} showAuto={this.props.showAuto}
                                     showRole={this.props.showRole}/>

                <div className="exceptions-list">
                    {lines}
                    {this.state.showNewRow && this.props.allowActions &&
                        <NewRow cancelEdit={this.cancelAddNewRow}
                                save={this.saveNewRow}
                                isSaveDisabled={this.isSaveDisabled}
                                rows={rows}
                                noDuplicates={this.props.noDuplicates}
                                showAuto={this.props.showAuto}
                                showRole={this.props.showRole}
                                translate={this.props.translate}/>
                    }
                    {this.props.allowActions &&
                        <AddNewRow addRow={this.addRow}
                                   disabled={this.state.editMode}
                                   showAuto={this.props.showAuto}
                                   showRole={this.props.showRole}
                                   noRows={lines.length <= 0}
                                   translate={this.props.translate}/>
                    }
                </div>

            </div>
        )
    }
}

const withTranslations = translate(Exceptions);
const mapStateToProps = function (store) {
    return {
        workflows: reduxSelectors.getWorkflows(store),
        activeWorkflow: reduxSelectors.getActiveWorkflow(store),
        workflowChanged: reduxSelectors.getWorkflowChangedStatus(store)
    };
};

const connected = connect(mapStateToProps, {})(withTranslations);
export default connected;

const ExceptionsHeaderRow = (props) => {
    return (
        <div className="row header-row py-2 m-0">
            <div className={props.showRole ? "col-md-2" : "col-md-4"}>
                {props.translate("workflowDetails.exceptions.requester")}
            </div>
            {props.showRole &&
                <div className={"col-md-2"}>
                    {props.translate("workflowDetails.exceptions.role")}
                </div>
            }
            <div className={props.showAuto ? "col-md-5" : "col-md-6"}>
                {props.translate("workflowDetails.exceptions.approver")}
            </div>
            {props.showAuto &&
                <div className="col-md-1 px-0">
                    {props.translate("workflowDetails.exceptions.auto")}
                    <span id="auto-tooltip"
                          className="checkbox-icon"
                          title={props.translate("workflowDetails.exceptions.autoTooltip")}>
                        <CircleQuestionMark size={ICON_SIZE.SMALL}/>
                    </span>
                </div>
            }
            <div className="col-md-2 text-right no-padding">
                {props.translate("workflowDetails.exceptions.action")}
            </div>
        </div>
    )
};

const AddNewRow = (props) => {
    let iconDefaultClass = "vismaicon vismaicon-add-circle vismaicon-dynamic";
    let iconClass = props.disabled ? iconDefaultClass + " disabled" : iconDefaultClass;

    return (
        <div className="row py-2 m-0" onClick={props.addRow}>
            <div className="col-md-10 no-side-padding">
                {props.noRows &&
                    <span className="text-disabled">
                        {props.translate("workflowDetails.exceptions.noEmployees")}
                    </span>
                }
            </div>
            <div className="col-md-2 d-flex align-items-center justify-content-end">
                <span className={iconClass}/>
            </div>
        </div>
    )
};

class NewRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            approver: undefined,
            requester: undefined,
            automaticApproval: false,
            focusFirst: false,
            role: undefined,
            saveDisabled: true
        };

        this.cancel = this.cancel.bind(this);
        this.save = this.save.bind(this);
        this.setApprover = this.setApprover.bind(this);
        this.setRequester = this.setRequester.bind(this);
        this.setRole = this.setRole.bind(this);
        this.setAutomaticApproval = this.setAutomaticApproval.bind(this);
    }

    componentDidMount() {
        this.setState({
            focusFirst: true
        });
    }

    cancel() {
        this.setState({
            approver: undefined,
            requester: undefined
        });

        this.props.cancelEdit();
    }

    save() {
        let users = (!this.state.automaticApproval && this.state.approver) ? this.state.approver.map((user => {
            return {valid: user.valid, value: user.value, label: user.label};
        })) : [this.state.approver];

        let newRowValid = false;
        let newRowLabel = "";
        let newRowValue = "";

        if (this.state.requester) {
            newRowValid = this.state.requester.valid;
            newRowLabel = this.state.requester.label;
            newRowValue = this.state.requester.value;
        }

        let newRow = {
            valid: newRowValid,
            label: newRowLabel,
            value: newRowValue,
            users: users,
            role: this.state.role,
            automaticApproval: this.state.automaticApproval
        };

        this.props.save(newRow);
    }

    setApprover(value) {
        this.setState({
            approver: value
        }, () => {
            this.setState({
                saveDisabled: this.props.isSaveDisabled(this.state.requester, this.state.approver, this.props.showRole, this.state.role)
            });
        });
    }

    setAutomaticApproval(event) {
        let approver = _.cloneDeep(this.state.approver);

        if (event.target.checked) {
            if (approver?.length > 0) {
                approver = {valid: approver[0].valid, label: approver[0].label, value: approver[0].value};
            }
        } else {
            approver = [{valid: approver.valid, label: approver.label, value: approver.value}];
        }

        this.setState({
            automaticApproval: event.target.checked,
            approver: approver
        }, () => {
            this.setState({
                saveDisabled: this.props.isSaveDisabled(this.state.requester, this.state.approver, this.props.showRole, this.state.role)
            });
        });

    }

    setRequester(value) {
        this.setState({
            requester: value,
            focusFirst: false
        }, () => {
            this.setState({
                saveDisabled: this.props.isSaveDisabled(this.state.requester, this.state.approver, this.props.showRole, this.state.role)
            });
        });
    }

    setRole(value) {
        this.setState({
            role: value
        }, () => {
            this.setState({
                saveDisabled: this.props.isSaveDisabled(this.state.requester, this.state.approver, this.props.showRole, this.state.role)
            });
        });
    }

    render() {
        const filterValues = this.props.noDuplicates ? (this.props.rows || []).map((row) => row.value) : [];

        return (
            <div className="row editing align-items-center py-2">
                <div className={`${this.props.showRole ? "col-md-2" : "col-md-4"}`}>
                    <FindEmployees propagateValue={this.setRequester}
                                   filterValues={filterValues}
                                   value={this.state.requester}
                                   refresh={this.state.focusFirst}
                                   translate={this.props.translate}/>
                </div>

                {this.props.showRole &&
                    <div className="col-md-2">
                        <ExceptionsRoles propagateValue={this.setRole}
                                         isRule={true}
                                         value={this.state.role}
                                         translate={this.props.translate}/>
                    </div>
                }
                <div className={this.props.showAuto ? "col-md-5" : "col-md-6"}>
                    <UserSearch multi={!this.state.automaticApproval}
                                propagateValue={this.setApprover}
                                value={this.state.approver}
                                includeAdminApprover={true}
                                translate={this.props.translate}
                                menuPosition={"fixed"}
                                menuPortalTarget={document.body}
                    />
                </div>
                {this.props.showAuto &&
                    <div className="col-md-1 text-center px-0 d-flex align-items-center justify-content-center">
                        <div className="checkbox m-0">
                            <input
                                id={`automatic-approval-checkbox-new`}
                                type="checkbox"
                                ref="automaticApproval"
                                onClick={this.setAutomaticApproval}
                            />
                            <label htmlFor={`automatic-approval-checkbox-new`}/>
                        </div>
                    </div>
                }
                <div className="col-md-2 text-end d-flex align-items-center justify-content-end">
                    <SaveCancelButtons
                        saveCallback={this.save}
                        saveDisabled={this.state.saveDisabled}
                        cancelCallback={this.cancel}
                        translate={this.props.translate}
                    />
                </div>
            </div>
        )
    }
}

class ExceptionsRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inEditMode: false,
            saveDisabled: true,
            focusFirst: false,
            ...this.getStateFromProps(props)
        };

        this.cancel = this.cancel.bind(this);
        this.delete = this.delete.bind(this);
        this.enterEditMode = this.enterEditMode.bind(this);
        this.exitEditMode = this.exitEditMode.bind(this);
        this.save = this.save.bind(this);
        this.setApprover = this.setApprover.bind(this);
        this.setRequester = this.setRequester.bind(this);
        this.setAutomaticApproval = this.setAutomaticApproval.bind(this);
    }

    getStateFromProps(props) {
        return {
            requester: {
                valid: props.data.valid,
                label: props.data.label,
                value: props.data.value
            },
            approver: props.data.automaticApproval ? {
                valid: props.data.users[0]?.valid,
                label: props.data.users[0]?.label,
                value: props.data.users[0]?.value
            } : props.data.users,
            automaticApproval: props.data.automaticApproval
        };
    }

    componentDidUpdate(prevProps) {
        // Update state when props.data changes and not in edit mode
        if (!this.state.inEditMode && prevProps.data !== this.props.data) {
            this.setState(this.getStateFromProps(this.props));
        }
    }

    cancel() {
        this.exitEditMode();
        this.setState({
            inEditMode: false,
            ...this.getStateFromProps(this.props)
        });

        if (this.props.cancelEdit)
            this.props.cancelEdit();
    }

    delete() {
        this.props.deleteRow(this.props.index);
    }

    enterEditMode() {
        this.props.enterEditMode();
        this.setState({
            inEditMode: true
        }, () => {
            //wait until the edit mode is enabled to force the focus on the first UserSearch input
            this.setState({
                focusFirst: true,
                saveDisabled: this.props.isSaveDisabled(this.state.requester, this.state.approver, this.props.showRole, this.props.role)
            });

        });
    }

    exitEditMode() {
        this.props.exitEditMode();
        this.setState({inEditMode: false});
    }

    save() {
        let newRow = _.cloneDeep(this.props.data);
        newRow.valid = this.state.requester.valid;
        newRow.value = this.state.requester.value;
        newRow.label = this.state.requester.label;
        newRow.users = this.state.automaticApproval ? [this.state.approver] : this.state.approver;
        newRow.automaticApproval = this.state.automaticApproval;
        this.exitEditMode();
        this.props.save(newRow, this.props.index);
    }


    setApprover(approver) {
        this.setState({
            approver: approver
        }, () => {
            this.setState({
                saveDisabled: this.props.isSaveDisabled(this.state.requester, this.state.approver, this.props.showRole, this.props.role)
            });
        });

    }

    setRequester(requester) {
        this.setState({
            requester: requester
        }, () => {
            this.setState({
                saveDisabled: this.props.isSaveDisabled(this.state.requester, this.state.approver, this.props.showRole, this.props.role)
            });
        });
    }

    setAutomaticApproval() {
        let isChecked = this.refs.automaticApproval.checked;
        let values = _.cloneDeep(this.props.data);
        values.automaticApproval = isChecked;
        let currentUsers = _.cloneDeep(this.state.approver);

        if (isChecked) {
            if (currentUsers.length > 0) {
                currentUsers = {
                    valid: currentUsers[0].valid,
                    label: currentUsers[0].label,
                    value: currentUsers[0].value
                };
            }
            values.users = [currentUsers.value];
        } else {
            currentUsers = [{valid: currentUsers.valid, label: currentUsers.label, value: currentUsers.value}];
            values.users = currentUsers.map(user => {
                return user.value
            });

        }
        this.setState({
            approver: currentUsers,
            automaticApproval: isChecked
        }, () => {
            this.setState({
                saveDisabled: this.props.isSaveDisabled(this.state.requester, this.state.approver, this.props.showRole, this.props.role)
            });
        });
    }

    render() {

        let role = this.props.data.role ? {
            label: this.props.data.role.label,
            value: this.props.data.role.value
        } : null;

        if (this.state.inEditMode && this.props.allowActions) {
            return (
                <div className="row editing align-items-center py-2">
                    <div className={this.props.showRole ? "col-md-2" : "col-md-4"}>
                        <FindEmployees propagateValue={this.setRequester}
                                       disabled={true}
                                       refresh={this.state.focusFirst}
                                       translate={this.props.translate}
                                       value={this.state.requester}/>

                    </div>

                    {this.props.showRole &&
                        <div className="col-md-2">
                            <ExceptionsRoles propagateValue={this.setRole}
                                             disabled={true}
                                             value={role}/>
                        </div>
                    }

                    <div className={this.props.showAuto ? "col-md-5" : "col-md-6"}>
                        <UserSearch propagateValue={this.setApprover}
                                    multi={!this.state.automaticApproval}
                                    value={this.state.approver}
                                    translate={this.props.translate}/>
                    </div>
                    {this.props.showAuto &&
                        <div className="col-md-1 text-center px-0">
                            <div className="checkbox">
                                <input
                                    id={`automatic-approval-checkbox-${this.props.index}`}
                                    type="checkbox"
                                    ref="automaticApproval"
                                    onClick={this.setAutomaticApproval}
                                    checked={this.state.automaticApproval}
                                />
                                <label htmlFor={`automatic-approval-checkbox-${this.props.index}`}/>
                            </div>
                        </div>
                    }
                    <div className="col-md-2 d-flex align-items-center justify-content-end">
                        <SaveCancelButtons
                            saveCallback={this.save}
                            saveDisabled={this.state.saveDisabled}
                            cancelCallback={this.cancel}
                            translate={this.props.translate}
                        />
                    </div>
                </div>
            )
        } else {

            let approversList = this.state.approver.length > 0 ? this.state.approver.map((app, index) => {
                return (
                    <span key={index} className="mx-1">
                        <Tag type={app.valid ? TagType.INFORMATION : TagType.WARNING} message={app.label}></Tag>
                    </span>);
            }) : (this.state.automaticApproval ?
                <Tag type={this.state.approver.valid ? TagType.INFORMATION : TagType.WARNING}
                     message={this.state.approver.label}></Tag> : []);

            return (
                <div className="row py-2 align-items-center m-0">
                    <div
                        className={(this.props.showRole ? "col-md-2" : "col-md-4") + (this.state.requester.valid === false ? " text-danger fw-bold" : "")}>
                        {this.state.requester &&
                            <span>{this.state.requester.label}</span>
                        }
                    </div>

                    {this.props.showRole &&
                        <div className="col-md-2">
                            {role &&
                                <span>{role.label}</span>
                            }
                        </div>
                    }

                    <div className={this.props.showAuto ? "col-md-5" : "col-md-6"}>
                        {approversList}
                    </div>
                    {this.props.showAuto &&
                        <div className="col-md-1 text-center px-0">
                            <div className="checkbox">
                                <input type="checkbox" checked={this.state.automaticApproval} disabled/>
                                <label/>
                            </div>
                        </div>
                    }
                    <div className="col-md-2 d-flex align-items-center justify-content-end">
                        <EditDeleteButtons
                            disabled={this.props.disabled}
                            editCallback={this.enterEditMode}
                            deleteCallback={this.delete}
                            translate={this.props.translate}
                        />
                    </div>
                </div>
            )
        }
    }
}
